<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <!-- <div v-if="coach" class="markDimmed" @click="coach = false"><img src="@/../static/img/mw/content/img_coachmark.png" class="mark" /></div> -->
    <div v-if="coach" class="markDimmed" @click="coach = false">
      <img src="https://www.welrixrental.co.kr/img_1/welmall_comm_img/1605844756245_img_coachmark.png" class="mark" />
    </div>
    <Header class="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="main transparent">
        <div class="mainVisual slide" id="slide1" ref="mainBanner">
          <template v-for="(list, listIndex) in bannerList">
            <ul class="slideList" v-if="list.bannerGroupId == 'BNGP0001'" :key="listIndex">
              <li v-for="(banner, bannerIndex) in list.bannerDtos" :key="bannerIndex">
                <a class="block">
                  <!-- <img src="@/../static/img/mw/content/img_main_banner01.png" alt="" /> -->
                  <img :src="banner.imgURL" alt="" />
                  <div class="desc">
                    <div class="normal vad_txt01" v-html="banner.bannerAreaTxt"></div>
                    <em class="tit vad_txt02" v-html="banner.topAreaTxt"></em>
                    <p class="txt normal vad_txt03" v-html="banner.bottomAreaTxt"></p>
                  </div>
                </a>
              </li>
            </ul>
          </template>
          <!-- <div class="swiper-scrollbar"></div> -->
        </div>
        <div class="tabWrap">
          <ul class="tabList pageTab">
            <li class="on">홈</li>
            <!-- <li @click="pageMove('af_main_top_menu', '/submain/benefits', 1)">나만의 혜택</li> -->
            <li @click="pageMove('af_main_top_menu', '/submain/theme', 2)">기획전</li>
            <!-- <li class="new" @click="pageMove('af_main_top_menu', '/submain/productSalePrice', 3)">초특가렌탈</li> -->
            <!-- <li @click="$router.push('/submain/deliveryMain')">정기배송</li> -->
            <li @click="pageMove('af_main_top_menu', '/submain/event', 4)">이벤트</li>
            <!-- <li :class="{ on: this.$route.name == 'appTestIndex' }" @click="$router.push('/appTestIndex')" ref="test">
              App 개발팀 테스트
            </li> -->
          </ul>
        </div>
        <ul class="bestGoods scroll">
          <li v-for="(category, index) in categoryList" :key="index">
            <a @click="pageMove('af_main_icon_menu', '/product/category/' + category.mainMenuIndex + '/sub/' + category.menuIndex, index + 1)">
              <span v-if="category.badgeYn == 'Y'" class="badge round">인기</span>
              <span class="img">
                <img :src="category.imgUrl" alt="" />
              </span>
              <span class="name">{{ category.menuName }}</span>
            </a>
          </li>
          <!-- <li>
            <a href="#link">
              <span class="btnMore"><span class="blind">전체보기</span></span>
              <span class="name">전체보기</span>
            </a>
          </li> -->
        </ul>

        <section v-if="userInfo" class="full hr">
          <!-- 로그인 후(s) -->
          <div class="titArea mt30">
            <h2 class="titH3 normal">
              <em>{{ userInfo.userName }}</em>
              님,
              <br />
              오늘도 행복한 하루 되세요.
            </h2>
          </div>
          <div class="utilMenu slide" id="utilList">
            <ul class="utilList slideList">
              <li v-if="summary.billInfo" @click="$router.push('/myPaymentInfo')">
                <div class="titWrap">
                  <em class="tit">수납결제</em>
                  <a class="right">
                    <span class="link">{{ summary.billInfo.productName }}</span>
                  </a>
                </div>
                <div class="bill">
                  <div class="amount">
                    <a>
                      <span class="tit">{{ summary.billInfo.thisMonth }}월 청구금액</span>
                      <span class="money">
                        <em>{{ summary.billInfo.thisMonthAmount | currency }}</em>
                        원
                      </span>
                    </a>
                  </div>
                  <div class="info">
                    <div class="block">
                      <span>결제수단 :</span>
                      <span class="pointC9">
                        <span v-if="summary.billInfo.payInfo.card == true">
                          [카드] {{ ' ' + summary.billInfo.payInfo.cardName }} {{ ' ' + summary.billInfo.payInfo.maskedCardNumber }}
                        </span>
                        <span v-else>{{ summary.billInfo.payInfo.bankName }} {{ ' ' + summary.billInfo.payInfo.maskedAccountNumber }}</span>
                      </span>
                    </div>
                    <div class="block">
                      <span>결제일 :</span>
                      <span class="pointC9">매월 {{ summary.billInfo.dueDate }}</span>
                    </div>
                  </div>
                  <a v-if="summary.billInfo.overdueAmounts != 0">
                    <span class="txtList_caution">미납금액 {{ summary.billInfo.overdueAmounts }}원</span>
                  </a>
                </div>
              </li>
              <li v-else-if="summary.couponYN == 'Y'" class="card cont01">
                <a>
                  <em class="tit">
                    쇼핑지원금
                    <br />
                    <span class="pointC1">10만원</span>
                    이 지급되었어요.
                  </em>
                  <p class="desc">웰몰의 다양한 상품을 이용해보세요!</p>
                  <p class="info">유효기간 12일 남음</p>
                </a>
              </li>
              <li v-else class="card">
                <em class="tit">오늘의 웰몰 인기상품 1위</em>
                <p class="txtXS pointC1" v-if="summary.personalInfo.ageNm != '' || summary.personalInfo.sexNm != ''">
                  #
                  <span v-if="summary.personalInfo.ageNm != ''">{{ summary.personalInfo.ageNm }}</span>
                  <span v-if="summary.personalInfo.sexNm != ''">{{ summary.personalInfo.sexNm }}의</span>
                  인기검색어
                </p>
                <p class="desc">웰릭스 음식물 처리기</p>
                <a @click="$router.push('/product/category/2/sub/4')" class="btn_l s round">상품 바로가기</a>
              </li>
              <li>
                <div class="titWrap">
                  <em class="tit">이용정보</em>
                  <span class="right">
                    웰몰 멤버쉽
                    <span class="badge round" v-if="summary.membership != 0">이용중</span>
                    <span class="badge round disabled" v-else>미이용</span>
                  </span>
                </div>
                <div class="cont">
                  <ul class="info">
                    <li style="width: 50%">
                      <a @click="$router.push('/myUsedRental')">
                        <span class="item">렌탈</span>
                        <span class="val">{{ summary.rentalCount }}</span>
                      </a>
                    </li>
                    <li style="width: 50%">
                      <a @click="$router.push({ name: 'myOrderList', params: { tab: false } })">
                        <span class="item">구매</span>
                        <span class="val">{{ summary.purchaseCount }}</span>
                      </a>
                    </li>
                    <!-- li>
                      <a>
                        <span class="item">정기배송</span>
                        <span class="val none">{{ summary.deliveryCount }}</span>
                      </a>
                    </li -->
                  </ul>
                </div>
              </li>
              <li>
                <div class="titWrap">
                  <em class="tit">AS 신청</em>
                  <a @click="$router.push('/asInfo')" class="right">
                    <span class="link">자세히 보기</span>
                  </a>
                </div>
                <div class="cont">
                  <ul class="info step">
                    <li>
                      <span class="item">신청</span>
                      <span class="val">{{ summary.asRequestCount }}</span>
                    </li>
                    <li>
                      <span class="item">접수</span>
                      <span class="val none">{{ summary.asReceiptCount }}</span>
                    </li>
                    <li>
                      <span class="item">방문</span>
                      <span class="val date">
                        <em v-if="summary.asReceiptCount != 0">{{ summary.visitDate }}예정</em>
                        <br />
                      </span>
                    </li>
                  </ul>
                </div>
              </li>
              <li v-if="summary.reviewYn" class="card cont02">
                <em class="tit">
                  이용중인 상품 리뷰를
                  <br />
                  공유해보세요.
                </em>
                <a @click="$router.push('/myReview')" class="btn_l s round">리뷰 작성하기</a>
              </li>
              <!-- <li class="more">
                <a href="#link">더보기</a>
              </li> -->
            </ul>

            <div class="linkArea">
              <em class="tit">바로가기</em>
              <div class="inner">
                <a @click="$router.push({ name: 'myVoucher', params: { dcmnCd: 'DCTP0002' } })" class="links">납부내역서</a>
                <a @click="$router.push('/myVoucher')" class="links">선납확인서</a>
                <a @click="$router.push('/paymentHistory')" class="links">결제현황</a>
              </div>
            </div>
          </div>
          <!-- 로그인 후(e) -->
        </section>

        <span class="stickyPoint t1"></span>
        <!-- header가 올라가는 시점 -->

        <div class="banner slide fraction hr" id="slideBanner">
          <template v-for="(list, listIndex) in bannerList">
            <ul class="slideList" v-if="list.bannerGroupId == 'BNGP0002'" :key="listIndex">
              <template v-if="bannerIndex == 0">
                <li v-for="(banner, bannerIndex) in list.bannerDtos" :key="bannerIndex">
                  <a @click="bannerClick(banner.bannerUrl)">
                    <!-- <a> -->
                    <span class="img">
                      <!-- <img src="@/../static/img/mw/temp/temp_banner01.png" alt="" /> -->
                      <img :src="banner.imgURL" alt="" />
                    </span>
                  </a>
                </li>
              </template>
            </ul>
          </template>
        </div>

        <section v-show="section1" class="hr">
          <div class="titArea">
            <h2 class="titH3">소모품은 여기 있어요!</h2>
          </div>
          <span id="v1"></span>
          <div class="player">
            <!-- <video-player
              ref="videoPlayer"
              class="vjs-custom-skin"
              :playsinline="true"
              @play="onPlayerPlay($event)"
              @ready="onPlayerReady($event)"
            ></video-player> -->
            <img src="https://www.welrixrental.co.kr/img_1/welmall_comm_img/1703641875952_test2.jpg" style="max-width: 100%" />
          </div>
          <!-- <div class="videoWrap">
            <a
              @click="
                popVideo.discntFlag == 'N' && popVideo.productCode && popVideo.productCode != '0'
                  ? pageMove('af_main_video', '/product/category/detail/' + popVideo.productCode, 1)
                  : ''
              "
            >
              <p class="title">
                {{ popVideo.videoName }}
                <br />
                {{ popVideo.productName }}
              </p>
              <p class="price">
                <span>
                  <em class="money">{{ popVideo.saleAmount | currency }}</em>
                  원
                </span>
              </p>
            </a>
            <p class="desc">{{ popVideo.videoContent }}</p>
            <p class="notice">한정수량! 카드청구할인도 놓치지 마세요!</p>
          </div> -->
        </section>

        <section v-if="section1" class="full">
          <div class="slide goodsList" id="slide3">
            <ul class="slideList">
              <li v-for="(product, index) in popProductList" :key="index">
                <a
                  @click="
                    product.discntFlag == 'N' && product.productIndex && product.productIndex != '0'
                      ? pageMove('af_main_best_product', '/product/category/detail/' + product.productIndex, product.productIndex)
                      : ''
                  "
                  class="block"
                >
                  <span class="img imgCover">
                    <!-- <img src="@/../static/img/mw/temp/temp_product02.png" alt="" /> -->
                    <img :src="product.thumbnail" alt="" />
                  </span>
                  <em class="tit">{{ product.displayName }}</em>
                  <p class="desc">{{ product.model }}</p>
                  <p class="price">
                    <span class="money">{{ product.saleAmount | currency }}</span>
                    원
                  </p>
                </a>
              </li>
            </ul>
            <div class="swiper-scrollbar"></div>
          </div>
        </section>

        <span class="stickyPoint t2"></span>
        <!-- header가 내려오는 시점 -->
        <span id="section2"></span>

        <!-- <section v-show="section2" class="hr"> -->
        <!-- <div class="titArea">
            <h2 class="titH3">이 상품은 어떠세요?</h2>
          </div>
          <div class="small" v-for="(video, index) in newVideoList" :key="index">
            <span :id="'video' + index"></span>
            <div class="player">
              <video-player
                ref="videoPlayer2"
                class="vjs-custom-skin"
                :playsinline="true"
                @play="onPlayerPlay($event)"
                @ready="onPlayerReady($event)"
              ></video-player>
            </div>
            <a
              @click="
                video.discntFlag == 'N' && video.productCode && video.productCode != '0'
                  ? pageMove('af_main_video', '/product/category/detail/' + video.productCode, index + 2)
                  : ''
              "
            >
              <p class="title mt15 mb5 txtM medium">
                {{ video.videoName }}
                <br />
                {{ video.productName }}
              </p>
              <p class="price" :class="{ mb40: index != 2 }">
                <span>
                  <em class="money" style="font-size: 1.6rem">{{ video.saleAmount | currency }}</em>
                  원
                </span>
              </p>
            </a>
          </div> -->
        <!-- </section> -->

        <!-- <section v-if="section2" class="full">
          <div class="titArea">
            <h2 class="titH3">새로 나온 상품이에요</h2>
          </div>
          <div class="slide goodsList" id="slide4">
            <ul class="slideList">
              <li v-for="(product, index) in newProductList" :key="index">
                <a
                  @click="
                    product.discntFlag == 'N' && product.productIndex && product.productIndex != '0'
                      ? pageMove('af_main_new_product', '/product/category/detail/' + product.productIndex, product.productIndex)
                      : ''
                  "
                  class="block"
                >
                  <span class="img imgCover">
                    <img :src="product.thumbnail" alt="" />
                  </span>
                  <em class="tit">{{ product.displayName }}</em>
                  <p class="desc">{{ product.model }}</p>
                  <p class="price">
                    <span class="money">{{ product.saleAmount | currency }}</span>
                    원
                  </p>
                </a>
              </li>
            </ul>
            <div class="swiper-scrollbar"></div>
          </div>
        </section> -->

        <span class="stickyPoint t3"></span>
        <!-- header가 올라가는 시점 -->

        <section v-if="section2" class="hr">
          <div class="titArea">
            <h2 class="titH3">고객들의 웰몰 이용 리뷰</h2>
          </div>
          <ul class="thumbList">
            <li v-for="(review, index) in reviewList" :key="index">
              <a
                @click="
                  review.productInfo.product.discntFlag == 'N' &&
                  review.productInfo.product.productIndex &&
                  review.productInfo.product.productIndex != '0'
                    ? pageMove('af_main_review', '/product/category/detail/' + review.productInfo.product.productIndex, 'query : { section: review }')
                    : ''
                "
                class="block"
              >
                <span class="img">
                  <img
                    :src="
                      review.photoPath != null &&
                      review.photoPath != '' &&
                      review.photoPath &&
                      review.photoPath.urls[0] != null &&
                      review.photoPath.urls[0] != '' &&
                      review.photoPath.urls[0]
                        ? review.photoPath.urls[0]
                        : review.productInfo.product.thumbnail
                    "
                    alt="상품"
                  />
                  <!-- <img
                    v-for="(photo, index) in review.photos"
                    :key="index"
                    :src="`data:image/${photo.fileTpMCntn === 'jpg' ? 'jpeg' : photo.fileTpMCntn};base64,${photo.file}`"
                  /> -->
                </span>
                <div class="info">
                  <span class="starRating">
                    <span :style="{ width: review.averageScore * 20 + '%' }"></span>
                  </span>
                  <span class="tit">{{ review.productInfo.product.productName }}</span>
                  <p
                    class="desc"
                    style="
                      overflow: hidden;
                      word-break: break-word;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 4;
                      -webkit-box-orient: vertical;
                      height: 74px;
                    "
                  >
                    {{ review.contents }}
                  </p>
                </div>
              </a>
            </li>
          </ul>
        </section>

        <section v-if="section2" class="full hr mg0">
          <div class="banner">
            <template v-for="(list, listIndex) in bannerList">
              <ul class="slideList" v-if="list.bannerGroupId == 'BNGP0004'" :key="listIndex">
                <li v-for="(banner, bannerIndex) in list.bannerDtos" :key="bannerIndex">
                  <a @click="pageMove('af_main_bottom_banner', banner.bannerUrl, bannerIndex + 1)">
                    <!-- <img src="@/../static/img/mw/temp/temp_banner_card.png" alt="" /> -->
                    <span class="img">
                      <img :src="banner.imgURL" alt="" />
                    </span>
                  </a>
                </li>
              </ul>
            </template>
          </div>
        </section>

        <section v-if="section2" class="hr">
          <div class="titArea">
            <h2 class="titH3">#웰몰을 만나보세요!</h2>
            <a class="btnIco_sns">welrix</a>
          </div>
          <ul class="imgList">
            <li>
              <a @click="instagram(0)" class="block">
                <span class="img">
                  <img src="@/../static/img/mw/temp/temp_instagram2.jpg" alt="" />
                  <span class="blind">항목명</span>
                </span>
              </a>
            </li>
            <li>
              <a @click="instagram(1)" class="block">
                <span class="img" style="">
                  <img src="@/../static/img/mw/temp/temp_instagram3.jpg" alt="" />
                  <span class="blind">항목명</span>
                </span>
              </a>
            </li>
            <li>
              <a @click="instagram(2)" class="block">
                <span class="img">
                  <img src="@/../static/img/mw/temp/temp_instagram4.jpg" alt="" />
                  <span class="blind">항목명</span>
                </span>
              </a>
            </li>
            <li>
              <a @click="instagram(3)" class="block">
                <span class="img">
                  <img src="@/../static/img/mw/temp/temp_instagram5.jpg" alt="" />
                  <span class="blind">항목명</span>
                </span>
              </a>
            </li>
            <li>
              <a @click="instagram(4)" class="block">
                <span class="img">
                  <img src="@/../static/img/mw/temp/temp_instagram6.jpg" alt="" />
                  <span class="blind">항목명</span>
                </span>
              </a>
            </li>
            <li>
              <a @click="instagram(5)" class="block">
                <span class="img more">
                  <!-- <img src="@/../static/img/mw/temp/temp_instagram1.jpg" alt="" /> -->
                  <span>더보기</span>
                </span>
              </a>
            </li>
          </ul>
        </section>

        <section v-if="section2" class="full hr">
          <div class="titArea mt30">
            <h2 class="titH3">웰몰 가이드북</h2>
          </div>
          <ul class="guideList scroll">
            <li>
              <a @click="getWebview(0)" class="block">
                <span class="img">
                  <img src="@/../static/img/mw/content/img_app_guide01.png" alt="웰몰 앱사용 가이드" />
                </span>
              </a>
            </li>
            <li>
              <a @click="getWebview(1)" class="block">
                <span class="img">
                  <img src="@/../static/img/mw/content/img_app_guide02.png" alt="A/S진행 가이드" />
                </span>
              </a>
            </li>
            <li>
              <a @click="getWebview(2)" class="block">
                <span class="img">
                  <img src="@/../static/img/mw/content/img_app_guide03.png" alt="웰릭스 음식물처리기 가이드" />
                </span>
              </a>
            </li>
            <!-- li>
              <a @click="getWebview(3)" class="block">
                <span class="img">
                  <img src="@/../static/img/mw/content/img_app_guide04.png" alt="정기배송 가이드" />
                </span>
              </a>
            </li -->
            <li>
              <a @click="getWebview(4)" class="block">
                <span class="img">
                  <img src="@/../static/img/mw/content/img_app_guide05.png" alt="웰몰이용 가이드" />
                </span>
              </a>
            </li>
            <li class="more" @click="$router.push('/guide')">
              <a>더보기</a>
            </li>
          </ul>
        </section>
        <Footer v-if="section2"></Footer>
      </div>
    </div>
    <!-- container(e) -->
    <BottomPop v-if="bottomPop" @closeToday="closeToday" @close="closeBottom"></BottomPop>
    <ConfirmPop v-if="confirmPop" @cancel="cancel" @confirm="confirm" @close="confirmPop = false">
      <p v-html="msg"></p>
    </ConfirmPop>
    <WebViewPop v-if="webViewPop" :pageName="pageName" @close="webViewPop = false">
      <div v-html="webView"></div>
    </WebViewPop>
    <!-- <infinite-loading spinner="circles" @infinite="infiniteHandler" /> -->
    <QuickMenu></QuickMenu>
    <!-- popup (s) -->
    <div class="popWrap" v-if="eventPopup">
      <div class="popup">
        <div class="popContain">
          <div class="popCont notice transparent">
            <div class="popBody" data-width="440px" data-position="top:100px" style="overflow: hidden">
              <div class="popInner">
                <!-- 본문 (s) -->

                <div class="tempArea" style="height: 529px; background-color: #fff; padding: 0">
                  <a href="https://www.welrixrental.co.kr/noticeView.do?num=44" target="_blank">
                    <img src="/img_1/micro/img/pc/content/pc_popup_contents.jpg" alt="" style="width: 100%" />
                  </a>
                </div>

                <!-- 본문 (e) -->
              </div>
            </div>

            <div class="btnArea sticky two half">
              <button type="button" class="btn_s" style="line-height: 45px" @click="closeEventPop('end')">다시 보지 않기</button>
              <button type="button" class="btn_s" style="line-height: 45px" @click="closeEventPop('close')">닫기</button>
            </div>

            <button type="button" class="btnIco_close" @click="closeEventPop('close')"><span>팝업 닫기</span></button>
          </div>
        </div>
      </div>
    </div>
    <!-- popup (e) -->
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import JwtService from '@/common/jwt.service';
import BottomPop from '@/components/popup/BottomPop';
import ConfirmPop from '@/components/popup/ConfirmPop';
import WebViewPop from '@/components/popup/WebViewPop';
import QuickMenu from '@/views/app/comm/QuickMenu';
import InfiniteLoading from 'vue-infinite-loading';
import ApiService from '@/common/api.service';
import * as customjs from '@/../static/js/m.front.js';
import Footer from '@/views/app/comm/Footer';
import VideoPlayer from '@/components/VideoPlayer.vue';

const Vimeo = require('vimeo').Vimeo;
const client = new Vimeo('df49391df984cc063fe1c6822fd18088e3bf6896', process.env.VUE_APP_VIMEO_SECRET, process.env.VUE_APP_VIMEO_TOKEN);

export default {
  name: 'Main',
  components: { BottomPop, ConfirmPop, WebViewPop, QuickMenu, InfiniteLoading, Footer, VideoPlayer },
  data() {
    return {
      pageIdx: 0, // 페이지 처리
      userInfo: false, // 사용자 정보
      bannerList: [], // 배너 리스트
      slide1ClickList: [], // slide1 클릭 이벤트용
      bannerClickList: [], // 배너 클릭 이벤트용
      categoryList: [], // 상단 카테고리
      popVideo: {
        cardDcAmount: 0,
      },
      // 인기상품 동영상
      popProductList: [], // 인기상품
      newVideoList: [
        {
          cardDcAmount: 0,
        },
      ], // 신상품 동영상
      newProductList: [], // 신상품
      reviewList: [], // 리뷰 요약
      summary: {}, // 유저 요약
      bottomPop: false, // 초기 하단 팝업
      confirmPop: false, // 확인 팝업
      webViewPop: false, // 웹뷰 팝업
      pageName: '',
      webView: '',
      section1: false, // 첫번째 영역
      section2: false, // 두번째 영역

      fcmToken: '',
      uuid: '',
      main_agree: '',

      // 동영상 옵션 사용안함
      /*
        playerOptions: {
          autoplay: false,
          muted: true,
          controls: true,
          preload: 'metadata',
          controlBar: {
            timeDivider: true,
            durationDisPlay: true,
          },
        },
        */
      coach: false, // 코치마크
      eventPopup: false, // 휴일 팝업
    };
  },
  watch: {
    async section2() {
      // 신상품 조회
      // await ApiService.service('GET', '/product/popular/main/MPTP0002')
      //   .then(({ data }) => {
      //     // console.log(data);
      //     this.newProductList = data.result;
      //   })
      //   .catch(({ response }) => {
      //     console.log(response);
      //   });

      // customjs.slideInit('#slide4', 0, false, 300, false, 'auto', 10); // 신상품 슬라이드

      // 리뷰 조회
      await ApiService.service('GET', '/product/review/main')
        .then(({ data }) => {
          console.log(data);
          this.reviewList = data.result;

          // 이미지 경로 암호화해서 가지고 오는 로직 > 오동작으로 주석.
          /*this.reviewList.forEach(data => {
            if (data.fileMngId != null && data.fileMngId != '') {
              const files = [];
              ApiService.service('GET', 'common/downloadFile/' + data.fileMngId)
                .then(({ data }) => {
                  if (data.isSucceed) {
                    //this.photoList = [...data.result];
                    data.result.forEach(item => {
                      const fileTpMCntn = item.exstFileLNm.split('.');
                      if (typeof item.file === 'string') {
                        item = {
                          ...item,
                          file: item.file,
                          fileTpMCntn: item.fileTpMCntn ? item.fileTpMCntn.trim() : fileTpMCntn[fileTpMCntn.length - 1].trim(),
                          exstFileLNm: item.exstFileLNm.trim(),
                          keyname: item.keyname.trim(),
                        };
                        files.push(item);
                      }
                    });
                  }
                })
                .catch(({ response }) => {
                  console.log('error : ' + response);
                })
                .finally(() => {
                  data.photos = [...files];
                });
            }
          }); */
          console.log(this.reviewList);
        })
        .catch(({ response }) => {
          console.log(response);
        });

      // 가이드 웹뷰 조회
      let webViews = await ApiService.service('GET', 'common/webView/WB000002');
      this.webViews = webViews.data.result;
    },
  },
  async created() {
    const coach = window.localStorage.getItem('coach');
    if (!coach) {
      this.coach = true;
      window.localStorage.setItem('coach', true);
    }

    // 동영상 상품 조회 (인기)
    // ApiService.service('GET', '/product/video/VDTP0001')
    //   .then(({ data }) => {
    //     console.log(data);
    //     if (data.result) {
    //       this.popVideo = data.result[0];
    //       const src = `https://player.vimeo.com/external/${this.popVideo.videoId}.m3u8?s=${this.popVideo.videoUrl}#t=0.1`;
    //       this.playVideo(this.popVideo.videoId, src);
    //     }
    //   })
    //   .catch(({ response }) => {
    //     console.log(response);
    //   });

    // 동영상 상품 조회 (신상품)
    // await ApiService.service('GET', '/product/video/VDTP0002')
    //   .then(({ data }) => {
    //     console.log(data);
    //     this.newVideoList = data.result;
    //   })
    //   .catch(({ response }) => {
    //     console.log(response);
    //   });

    // const videoListLength = this.newVideoList.length;
    // if (videoListLength > 0) {
    //   for (let i = 0; i < videoListLength; i++) {
    //     let src = `https://player.vimeo.com/external/${this.newVideoList[i].videoId}.m3u8?s=${this.newVideoList[i].videoUrl}#t=0.1`;
    //     this.playVideo(this.newVideoList[i].videoId, src, i);
    //   }
    // }

    window.addEventListener('scroll', this.handleScroll); // 스크롤 이벤트
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  async mounted() {
    // const holiday = window.localStorage.getItem('816');
    // const now = this.$moment(new Date()).format('YYYYMMDDHH');
    // const end = this.$moment(new Date('2021-08-17 00:00:00')).format('YYYYMMDDHH');
    // if (!(holiday == 'true') && now <= end && now >= '2021081300') {
    //   this.eventPopup = true;
    // }

    this.JWTsetMarParam(); // JWT set Marparam (echo_key, g_code)
    /* TODO 인스타그램 */
    const vm = this;

    // 친구추천
    const friendObj = this.$cookies.get('friendObj');
    //console.log(friendObj);
    if (friendObj != null) {
      this.msg = `렌탈료 할인 가능한 친구 추천 상품이 있습니다.<br/>렌탈 진행 페이지로 이동하시겠습니까?`;
      this.confirmPop = true;
    }

    // 메인화면 배너 조회
    await ApiService.service('GET', '/resource/banner/16')
      .then(({ data }) => {
        console.log(data);
        this.bannerList = data.result;
        for (var i = 0; i < this.bannerList.length; i++) {
          if (this.bannerList[i].bannerGroupId == 'BNGP0001') {
            this.slide1ClickList = this.bannerList[i].bannerDtos;
          }
          if (this.bannerList[i].bannerGroupId == 'BNGP0002') {
            this.bannerClickList = this.bannerList[i].bannerDtos;
          }
        }
      })
      .catch(({ response }) => {
        console.log(response);
      });

    // export function slideInit(target, $auto, $sideCtrlUse, $fadeMode, $loop, $perView, $between, $pagType, clickEvent, callback, $initialSlide)
    customjs.slideInit('#slide1', 5000, false, 300, true, 'auto', 0, null, vm.slide1ClickEvent); // 최상단 배너
    customjs.addStiky('.tabList.pageTab');
    customjs.init();
    customjs.slideInit('#slideBanner', 5800, false, 300, true, 1, 0, 'fraction', vm.bannerClickEvent); // 쿠폰 배너

    // 메인화면 카테고리 리스트 조회
    ApiService.service('GET', '/common/category/main')
      .then(({ data }) => {
        this.categoryList = data.result;
      })
      .catch(({ response }) => {
        console.log(response);
      });

    if (JwtService.getToken()) {
      // 요약정보 조회
      await ApiService.service('GET', '/user/auth/main/summary')
        .then(({ data }) => {
          if (data.isSucceed) {
            this.summary = data.result;
            this.userInfo = JwtService.getUserInfo();
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
      ApiService.service('GET', '/order/auth/rentalList')
        .then(({ data }) => {
          this.summary.rentalCount = data.result.length;
        })
        .catch(({ response }) => {
          console.log(response);
        });

      customjs.slideInit('#utilList', 0, false, 300, false, 1, 10, ''); // 유저 요약 슬라이드
    }

    // 공지사항, 코치마크있을시 비노출
    if (!this.coach) {
      const notice = this.$cookies.get('notice');
      if (notice == null) {
        window.openPop('bottomPop', 'closeBottomPop()');
        this.bottomPop = true;
      }
    }

    // 인기 상품 조회
    await ApiService.service('GET', '/product/popular/main/MPTP0001')
      .then(({ data }) => {
        if (data.result) {
          this.section1 = true;
          this.popProductList = data.result;
        }
      })
      .catch(({ response }) => {
        console.log(response);
      });

    customjs.slideInit('#slide3', 0, false, 300, false, 'auto', 10); // 인기상품 슬라이드
  },
  methods: {
    closeEventPop(type) {
      console.log('123131');
      if (type == 'end') window.localStorage.setItem('816', true);
      this.eventPopup = false;
    },
    JWTsetMarParam() {
      // getMarparam에 값이 없을 경우 JWT토큰에 값 세팅
      console.log('jwt => ' + JwtService.getMarParam());
      if (JwtService.getParamTime() != null && JwtService.getParamTime != null) {
        let now = new Date();
        let diffTime = now - diffTime;
        //40분 이상 된 G코드, 에코키 삭제
        if (diffTime / (1000 * 60) > 40) {
          JwtService.destroyMarParam();
        }
      }
      var param = location.search.substr(location.search.indexOf('?') + 1);
      param = param.split('&');
      var temp = '';
      for (var i = 0; i < param.length; i++) {
        temp = param[i].split('=');
        if (temp[0] == 'g') {
          this.gCode = temp[1];
        }
        if (temp[0] == 'echo_key') {
          this.echoKey = temp[1];
        }
        if (!(this.echoKey == undefined && this.gCode == undefined)) {
          var marParam = this.echoKey + '/' + this.gCode;
          JwtService.setMarParam(marParam);
          this.marParam = JwtService.getMarParam();
        }
      }
      //  if(!JwtService.getMarParam() || JwtService.getMarParam == null){
      //     var param = location.search.substr(location.search.indexOf("?") + 1);
      //     param = param.split("&");
      //     var temp = '';
      //     for (var i = 0; i < param.length; i++) {
      //         temp = param[i].split("=");
      //         if (temp[0] == 'g') { this.gCode = temp[1]; }
      //         if (temp[0] == 'echo_key') { this.echoKey = temp[1]; }
      //         if(!(this.echoKey == undefined && this.gCode == undefined)){
      //           var marParam = this.echoKey + "/" + this.gCode;
      //           JwtService.setMarParam(marParam);
      //           this.marParam = JwtService.getMarParam();
      //         }
      //     }
      //   }
    },
    getTime() {
      return this.$moment(new Date()).format('YYYYMMDD');
    },
    // infiniteHandler($state) {
    //   this.pageIdx += 1; // page NO + 1
    //   console.log('page:' + this.pageIdx); // page No
    //   if (this.pageIdx == 1) {
    //     // this.section2 = true;
    //   } else if (this.pageIdx == 2){
    //     this.section2 = true;
    //   }
    //   if(this.pageIdx == 2) $state.complete();
    //   else $state.loaded();
    // },
    getWebview(num) {
      const params = {
        af_content_id: num + 1,
      };
      //const appsFlyerParams = JSON.stringify(params);
      window.appsFlyer('af_main_guidebook', params);
      this.webViewUrl = this.webViews[num].filePath;
      this.pageName = this.webViews[num].pageName;
      this.$router.push({ name: 'guideDetail' + num, params: { webViewUrl: this.webViewUrl, pageName: this.pageName } });
    },
    cancel() {
      this.$cookies.remove('friendObj');
      this.confirmPop = false;
    },
    confirm() {
      const friendObj = this.$cookies.get('friendObj');
      this.$router.push('/friendRecommendRecv/' + friendObj.friendCode + '/' + friendObj.productIndex);
    },
    close() {
      this.$cookies.remove('friendObj');
      this.confirmPop = false;
    },
    instagram(index) {
      const params = {
        af_content_id: index + 1,
      };
      window.appsFlyer('af_main_sns', params);
      let url = '';
      if (index == 0) url = 'https://www.instagram.com/p/CGy2mZ_HlGq/';
      else if (index == 1) url = 'https://www.instagram.com/p/CGrW_D8H-uV/';
      else if (index == 2) url = 'https://www.instagram.com/p/CGopY7WnYxD/';
      else if (index == 3) url = 'https://www.instagram.com/p/CGhGBC0Hmup/';
      else if (index == 4) url = 'https://www.instagram.com/p/CGZVgqTnswK/';
      else url = 'https://www.instagram.com/welrix.official/';
      // url = 'https://www.instagram.com/welrix.official/';
      window.location.href = url;
    },
    //eslint-disable-next-line no-unused-vars
    handleScroll(event) {
      // 현재 문서의 높이
      let scrollHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
      // 현재 스크롤 탑의 값
      let scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
      // 현재 화면 높이 값
      let clientHeight = document.documentElement.clientHeight;
      if (scrollTop + clientHeight + 200 > scrollHeight) {
        if (this.section1) this.section2 = true;
      }

      let distance = 330;

      // 인기동영상
      // if (this.section1) {
      //   if (document.getElementById('v1') != null) {
      //     let video1 = document.getElementById('v1').getBoundingClientRect().top;
      //     if (video1 < distance && video1 > 0) this.$refs.videoPlayer.player.play();
      //     else {
      //       if (!this.$refs.videoPlayer.player.paused()) this.$refs.videoPlayer.player.pause();
      //     }
      //   }
      // }

      // 동영상 3개
      // if (this.section2) {
      //   if (document.getElementById('video0') != null) {
      //     let video2 = document.getElementById('video0').getBoundingClientRect().top;
      //     if (video2 < distance && video2 > 0) this.$refs.videoPlayer2[0].player.play();
      //     else {
      //       if (!this.$refs.videoPlayer2[0].player.paused()) this.$refs.videoPlayer2[0].player.pause();
      //     }
      //   }

      //   if (document.getElementById('video1') != null) {
      //     let video3 = document.getElementById('video1').getBoundingClientRect().top;
      //     if (video3 < distance && video3 > 0) this.$refs.videoPlayer2[1].player.play();
      //     else {
      //       if (!this.$refs.videoPlayer2[1].player.paused()) this.$refs.videoPlayer2[1].player.pause();
      //     }
      //   }

      //   if (document.getElementById('video2') != null) {
      //     let video4 = document.getElementById('video2').getBoundingClientRect().top;
      //     if (video4 < distance && video4 > 0) this.$refs.videoPlayer2[2].player.play();
      //     else {
      //       if (!this.$refs.videoPlayer2[2].player.paused()) this.$refs.videoPlayer2[2].player.pause();
      //     }
      //   }
      // }
    },
    closeBottom() {
      this.$cookies.set('notice', 'close', '1y');
      this.bottomPop = false;
      window.closeBottomPop();
    },
    closeToday() {
      this.$cookies.set('notice', 'today', '1y');
      window.cookieSync();
      this.bottomPop = false;
      window.closeBottomPop();
    },
    bannerClickEvent(index) {
      const params = {
        af_content_id: index + 1,
      };
      window.appsFlyer('af_main_middle_banner', params);
      this.$router.push(this.bannerClickList[index].bannerUrl);
    },
    slide1ClickEvent(index) {
      const params = {
        af_content_id: index + 1,
      };
      window.appsFlyer('af_main_top_banner', params);
      this.$router.push(this.slide1ClickList[index].bannerUrl);
    },
    bannerClick(url) {
      if (this.userInfo) this.$router.push('/benefits/coupon');
      else this.$router.push(url);
    },
    onPlayerPlay(player) {
      console.log('player play!', player);
    },
    onPlayerReady(player) {
      console.log('player ready!', player);
    },
    playVideo(id, source, target) {
      const video = {
        withCredentials: false,
        type: 'application/x-mpegurl',
        src: source,
      };

      let ref = this.$refs.videoPlayer;
      if (target != null) ref = this.$refs.videoPlayer2[target];
      let thumbnail = '';

      client.request(
        {
          method: 'GET',
          path: `videos/${id}/pictures`,
        },
        // eslint-disable-next-line no-unused-vars
        function (error, body, status_code, headers) {
          if (error) {
            console.log(error);
          }
          console.log(body);
          thumbnail = body.data[0].sizes[3].link_with_play_button;
          ref.player.reset();
          ref.player.poster(thumbnail);
          ref.player.src(video);
        },
      );
    },
    pageMove(type, url, content, query) {
      const params = {
        af_content_id: content,
      };
      window.appsFlyer(type, params);

      if (query != null) {
        this.$router.push({ path: url, query: { query } });
      } else {
        this.$router.push(url);
      }
    },
  },
};
</script>

<style scoped>
.player {
  padding-top: 0px;
}
</style>
